module.exports = __webpack_public_path__ + "static/media/iconCheckOn.9b80d5cc.png";